<template>
  <div id="app" class="app-container">
    <HeaderComponent />
    <transition
        name="fade"
        mode="out-in"
    >
      <router-view :key="$route.path" />
    </transition>
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from './components/HeaderComponent.vue'
import FooterComponent from './components/FooterComponent.vue'

export default {
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style>
/* 全局样式 */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f9f9f9;
  padding-top: 0; /* 移除默认的顶部内边距 */
}

/* 主容器 */
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  color: #000000;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Header 和 Footer 样式 */
header {
  background-color: #2c3e50; /* 深蓝色背景 */
  color: #ffffff; /* 白色文字 */
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

footer {
  background-color: #2c3e50; /* 深蓝色背景 */
  color: #ffffff; /* 白色文字 */
  padding: 1rem 0;
  margin-top: auto; /* 确保 Footer 始终在底部 */
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  header, footer {
    padding: 0.5rem 0;
  }
}
</style>
